import React from 'react';

export interface IProps {
  fillColor?: string;
}

const QuotationIcon: React.FC<IProps> = (props) => {
  return (
    <svg width="64" height="48" viewBox="0 0 64 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.0678234 34.4943C0.808876 41.6354 6.80467 47.2943 14.0131 47.6312C22.5015 48.0354 29.5078 41.2985 29.5078 32.8775C29.5078 26.6796 25.6678 21.4248 20.2783 19.2017L28.5647 2.22489C29.0363 1.21437 28.2952 0.00170135 27.2173 0.00170135H21.5584C21.0868 0.00170135 20.6152 0.203823 20.3457 0.608032L2.56046 24.5912C0.674147 27.4206 -0.269018 30.8564 0.0678234 34.4943Z" fill={props.fillColor ?? "black"} />
      <path d="M48.5053 47.6312C56.9937 48.0354 64 41.2985 64 32.8775C64 26.6796 60.16 21.4248 54.7705 19.2017L63.0568 2.22489C63.5284 1.21437 62.7874 0.00170135 61.7095 0.00170135H56.0505C55.579 0.00170135 55.1074 0.203823 54.8379 0.608032L37.0527 24.5912C35.1663 27.3533 34.2232 30.7891 34.6274 34.427C35.3685 41.6354 41.3642 47.2943 48.5053 47.6312Z" fill={props.fillColor ?? "black"} />
    </svg>
  )
}

export default QuotationIcon;